import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DisconnectedSaleRoutingModule } from './disconnected-sale-routing.module';
import { DisconnectedSaleComponent } from './disconnected-sale.component';
import { RouterModule } from '@angular/router';
import { FooterModule } from '../shared/components/footer/footer.module';
import { IdentificationComponent } from './identification/identification.component';
import { DisconnectedSaleHeaderModule } from "../shared/components/disconnected-sale-header/disconnected-sale-header.module";
import { SuccessComponent } from './success/success.component';
import { PaymentComponent } from './payment/payment.component';


@NgModule({
  declarations: [
    DisconnectedSaleComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    DisconnectedSaleRoutingModule,
    FooterModule,
    DisconnectedSaleHeaderModule
],
  exports: [
    DisconnectedSaleComponent
  ],
})
export class DisconnectedSaleModule { }
